import { Slice } from "gatsby";
import * as React from "react";
import { PropsWithChildren } from "react";

type Props = PropsWithChildren<{ desktop?: boolean; toggle?: () => void }>;

const NavbarLinks: React.FC<Props> = (props: Props) => {
  function closeSidebar() {
    if (props.toggle) props.toggle();
  }
  return (
    <nav
      onClick={() => closeSidebar()}
      className={`m-navbarlinks navbarlinks${
        props.desktop ? "__desktop" : "__sidebar"
      }`}
    >
      <Slice alias={"mainMenu"} />
    </nav>
  );
};

export default NavbarLinks;
